export enum HideableLoginOptions {
	Logo = "logo",
	Sso = "sso",
	ForgotPassword = "forgotPassword",
	Signup = "signUp",
}

export interface TenantDomain {
	id: string | null
	domainPath: string
	samlProviders: SamlProvider[]
	hasImage?: boolean
	tenantId?: string | null
	loginOptions?: DomainLoginOptions | null
}

export interface DomainLoginOptions {
	showSsoBelowLogin: boolean
	hiddenElements: HideableLoginOptions[]
}

export interface SamlProvider {
	key: string
	title: string
	issuer: string
	loginUrl: string
	metaDataUrl: string
	logoutUrl: string
	providerTokenEndpoint: string
	providerClientSecret: string
	allowCreate: boolean

	roleClaim: string | null
	requiredRole: string
	teamRoles: { [role: string]: string[] }

	autoLogin: boolean

	redirectUrl?: string
}

export interface LoginDomain {
	tenantId: string
	samlProviders: SamlUrl[]
	showSsoBelowLogin: boolean
	hiddenElements: HideableLoginOptions[]
}

export interface SamlUrl {
	key: string
	title: string
	url: string | null
	error: string | null
	autoLogin: boolean
}
